module.exports = __webpack_public_path__ + "img/DS124.1f3e1898.png";